export const FETCH_STABILITY_DATA = 'FETCH_STABILITY_DATA';
export const FETCH_RELATED_SITES = 'FETCH_RELATED_SITES';
export const FETCH_HTTPCODES_SERIES = 'FETCH_HTTPCODES_SERIES';
export const FETCH_HTTPCODES_SERIES_QUESTIONS = 'FETCH_HTTPCODES_SERIES_QUESTIONS';
export const FETCH_HTTPCODES = 'FETCH_HTTPCODES';
export const FETCH_HTTPCODES_QUESTIONS = 'FETCH_HTTPCODES_QUESTIONS';
